// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool } from 'prop-types'
import { Spinner } from './styles'

const LoadingIcon = ({ isLoading }) => (
  isLoading
    ? <Spinner />
    : null
)

LoadingIcon.propTypes = {
  isLoading: bool.isRequired,
}

export default LoadingIcon
